var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFireFill = function SvgFireFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fire-fill_svg__a)",
    d: "M12.759 7.383c-.289-.636-.7-1.2-1.225-1.674l-.43-.388a.12.12 0 0 0-.192.048l-.192.542c-.12.34-.34.688-.652 1.029a.09.09 0 0 1-.094.025.1.1 0 0 1-.03-.018.09.09 0 0 1-.03-.07c.055-.874-.21-1.86-.793-2.934a5.2 5.2 0 0 0-1.987-2.074l-.61-.353a.118.118 0 0 0-.177.106l.033.697c.022.477-.034.898-.167 1.249a4.1 4.1 0 0 1-.695 1.184 4.3 4.3 0 0 1-.701.67 5.14 5.14 0 0 0-1.482 1.765 4.98 4.98 0 0 0-.126 4.218 5.1 5.1 0 0 0 1.116 1.612 5.2 5.2 0 0 0 1.653 1.085c.641.264 1.32.398 2.022.398a5.3 5.3 0 0 0 2.023-.397 5.16 5.16 0 0 0 2.768-2.697 4.9 4.9 0 0 0 .41-1.976c0-.709-.149-1.397-.443-2.047"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fire-fill_svg__a",
    x1: 8,
    x2: 8,
    y1: 1.5,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F80"
  })))));
};
export default SvgFireFill;